import { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";

// Plain, neutral backdrop that loads the REAL embed.js for a tenant slug.
// ?view=portal auto-opens the customer portal (account) drawer.
// Used as the iframe source for the in-dashboard Preview tab and standalone full-page preview.
export default function PreviewHost() {
  const { slug } = useParams();
  const [params] = useSearchParams();
  const view = params.get("view");
  const isPortal = view === "portal";
  const [store, setStore] = useState(null);

  useEffect(() => {
    if (!slug) return;
    let cancelled = false;
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/public/tenant/${slug}`)
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => { if (!cancelled && d) setStore({ name: d.name, logo: d.logo_url }); })
      .catch(() => {});
    return () => { cancelled = true; };
  }, [slug]);

  useEffect(() => {
    if (!slug) return;
    document.title = `MorrCart preview · ${slug}`;
    const s = document.createElement("script");
    s.id = "morrcart-embed";
    s.src = `${window.location.origin}/embed.js`;
    s.setAttribute("data-tenant", slug);
    s.setAttribute("data-morrcart-context", "hosted");
    document.body.appendChild(s);

    let timer = null;
    if (isPortal) {
      let tries = 0;
      timer = setInterval(() => {
        tries += 1;
        if (window.MorrCart && typeof window.MorrCart.openAccount === "function") {
          window.MorrCart.openAccount();
          clearInterval(timer);
        } else if (tries > 40) {
          clearInterval(timer);
        }
      }, 150);
    }

    return () => {
      if (timer) clearInterval(timer);
      s.remove();
      document.querySelectorAll("[data-morrcart]").forEach((n) => n.remove());
      window.__morrcartLoaded = undefined;
      window.MorrCart = undefined;
    };
  }, [slug, isPortal]);

  return (
    <div style={{ minHeight: "100vh", background: "#ffffff", color: "#111111", fontFamily: "system-ui, -apple-system, sans-serif" }}>
      <div style={{ maxWidth: 1000, margin: "0 auto", padding: "40px 24px" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 28 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }} data-testid="preview-store-header">
            {store?.logo && <img src={store.logo} alt="" style={{ height: 32, width: 32, borderRadius: 8, objectFit: "cover" }} />}
            <strong style={{ fontSize: 18 }}>{store?.name || "\u00A0"}</strong>
          </div>
          <a href="#account" data-morrcart-account style={{ color: "#111", fontSize: 14, textDecoration: "none" }} data-testid="preview-account-link">My Account / Login</a>
        </div>
        {!isPortal && <div data-morrcart-products data-group-by="category" data-testid="preview-products" />}
      </div>
    </div>
  );
}
